import React, { useState, useEffect} from 'react';
import { useParams, useHistory } from "react-router-dom";
import Tooltip from '@material-ui/core/Tooltip';
import { Inicio } from '../components/Inicio';
import logo from '../assets/img/logo.png';
import SearchIcon from '@material-ui/icons/Search';
import { Loading } from '../components/Loading';
import useWindowDimensions from './Login';
import {getPedidos} from '../controller';
import '../styles/index.css';

const encontrar = (ids, data) => {
  const result = [];
  ids.forEach(element => {
    let cont = 0
    let find =[]
    data.forEach((item, index) => {
      if (item.code === element) {
        cont++;
        find.push(index);
      }
    });
    result.push({
      id: element,
      contador: cont,
      ubic: find,
    });
  });
return(result);
}

export const Home = (props) => {
  const history = useHistory();
  let { id } = useParams();
  let {cliente} = useParams();
  const [loading, setLoading] = useState(true);
  const { width } = useWindowDimensions();
  const [search, setSearch] = useState((id.replace(/ /g, "")).toUpperCase() );
  const [ pedidos,setPedidos] = useState(null);
  let ids =  search.split(",");
  ids = [...new Set(ids)];
  cliente = (cliente !== undefined )? cliente.replace(/ /g, ""):'';
  const [resultado, setResultado] = useState([]);
  
  useEffect(() => {
    let mounted = true;
    setLoading(true);
    getPedidos(search, cliente)
      .then((pedidos) => {
        console.log('pedidos => ', pedidos);
        if (mounted) {
          setPedidos( pedidos.sort(function (a, b) {
            if (a.appointment_time > b.appointment_time) {
              return -1;
            }
            if (a.appointment_time < b.appointment_time) {
              return 1;
            }
            // a must be equal to b
            return 0;
          }));
          setResultado(encontrar(ids,pedidos));
          setLoading(false);
        }
      })
      .catch((e) => console.error(e))
      return function cleanup() {
        mounted = false;
      };
     
  }, [search]);
  
  function handleClick(e) {
   const mobile = document.getElementsByName("searchMobile")[0].value;
   setSearch((mobile.replace(/ /g, "")).toUpperCase());
  }

  function out(e) {
   history.push(`/`);
   }

  return (
    <div >
      <main >
        <div className="div-header-home">
          <div>
          <Tooltip title="Volver al inicio">
            <img className="logo-home" src={logo} alt="logo" onClick={out} />
            </Tooltip>
          </div>
          {(width > 768) ?
            <div className="search-box">
              <div className="div-icon-search">
                <SearchIcon style={{ color: 'rgba(0, 0, 0, 0.5)' }} />
              </div>
              <input type="text" name="search" placeholder="Número de seguimiento" className="input-search-bar"  onKeyPress={(e) => {
                if(e.key==="Enter"){
                  setSearch(((e.target.value).replace(/ /g, "")).toUpperCase() );
                }}}/>
            </div> :
            <div className="search-box2">
              <div className="div-icon-search">
                <SearchIcon style={{ color: 'rgba(0, 0, 0, 0.5)' }} />
              </div>
              <input type="text" name="searchMobile" placeholder="Número de seguimiento" className="input-search-bar"  />
              <button className="btn-buscar-home"
                type="button"
                onClick={handleClick}>
                Buscar </button>
            </div>}

        </div>
       {
         (loading)?<Loading/>:<Inicio arr ={pedidos} busqueda={resultado} />
       }
      </main>
    </div>
  );
};
